import Vue from "vue";
import VueRouter from "vue-router";
import { CAR_TYPES } from "../const/const";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/:cartype",
    name: "Home",
    component: Home,
    beforeEnter(to, from, next) {
      let cartype = to.path.split("/")[1];
      // URLから取得したpathが定数で定義されているものとマッチした時
      if (CAR_TYPES.some(CAR_TYPE => CAR_TYPE.id === cartype)) {
        next();
      }
      // マッチしなかった時はルートに遷移する
      else {
        next({
          path: `/`
        });
      }
    }
  },
  {
    path: "*",
    component: Home,
    beforeEnter(to, from, next) {
      let cartype = to.path.split("/")[1];
      // URLから取得したpathが定数で定義されているものとマッチした時
      if (CAR_TYPES.some(CAR_TYPE => CAR_TYPE.id === cartype)) {
        next({
          path: `/${cartype}`
        });
      }
      // マッチしなかった時はルートに遷移する
      else {
        next({
          path: `/`
        });
      }
    }
  }
];

const router = new VueRouter({
  routes
});

export default router;
